import Controller from "./contractorInvoice.controller";
import template from "./contractorInvoice.html";

const contractorInvoice = {
  template,
  controller: Controller,
};

export default contractorInvoice;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoice/contractorInvoice.component.js